import React, { Fragment } from 'react'
import { Link } from 'gatsby'

import * as styles from './SimpleButton.module.scss'
import { Icon } from '@iconify/react'

const SimpleButton = ({
  buttonData = null,
  icon = null,
  type,
  url = null,
  text = null,
  buttonHandler = null,
  location = 'internal',
  trailingIcon = true,
  ...args
}) => {
  let buttonContent = (
    <Link
      to={buttonData?.url ? buttonData.url : url}
      state={buttonData?.state ? buttonData.state : {}}
      {...args}
      className={`btn ${styles.simple_btn} ${styles[`${type}`]}`}
    >
      {icon ? (
        <Icon
          className={styles.btn_icon}
          icon={icon}
          inline={true}
          width="20"
          height="20"
          vAlign="center"
        />
      ) : (
        ''
      )}
      {buttonData?.text ? buttonData.text : text}{' '}
      {trailingIcon && (
        <Icon
          icon="eva:arrow-forward-fill"
          inline={true}
          width="18"
          height="18"
          vAlign="center"
        />
      )}
    </Link>
  )
  if (buttonHandler) {
    buttonContent = (
      <button
        onClick={buttonHandler}
        className={`btn ${styles.simple_btn} ${styles[`${type}`]}`}
      >
        {icon ? (
          <Icon
            className={styles.btn_icon}
            icon={icon}
            inline={true}
            width="20"
            height="20"
            vAlign="center"
          />
        ) : (
          ''
        )}
        {buttonData?.text ? buttonData.text : text}{' '}
        {trailingIcon && (
          <Icon
            icon="eva:arrow-forward-fill"
            inline={true}
            width="18"
            height="18"
            vAlign="center"
          />
        )}
      </button>
    )
  } else if (location === 'external' || buttonData?.location === 'external') {
    buttonContent = (
      <a
        href={buttonData?.url ? buttonData.url : url}
        state={buttonData?.state ? buttonData.state : {}}
        {...args}
        className={`btn ${styles.simple_btn} ${styles[`${type}`]}`}
      >
        {icon ? (
          <Icon
            className={styles.btn_icon}
            icon={icon}
            inline={true}
            width="20"
            height="20"
            vAlign="center"
          />
        ) : (
          ''
        )}
        {buttonData?.text ? buttonData.text : text}{' '}
        {trailingIcon && (
          <Icon
            icon="eva:arrow-forward-fill"
            inline={true}
            width="18"
            height="18"
            vAlign="center"
          />
        )}
      </a>
    )
  }
  return <Fragment>{buttonContent}</Fragment>
}

export default SimpleButton
